function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, React.createElement("ellipse", {
  cx: 70,
  cy: 60,
  rx: 70,
  ry: 17,
  fill: "#F7F7F7"
}), React.createElement("path", {
  d: "M34.6513 54.9141L29 0H56.2549L61.3592 6.10223L87.83 5.38616L95.1668 11.7815L46.5459 11.6182C46.1106 22.8764 45.1879 46.485 43.4785 53.0728C41.7692 59.6607 36.7087 57.1419 34.6513 54.9141Z",
  fill: "#C5C5C5"
}), React.createElement("path", {
  d: "M43.7952 49.6621C43.415 58.3503 38.3149 57.4172 35.9014 56.1044C35.9014 56.1044 40.4739 61 43.7952 61H105.07C107.145 61 108.864 59.4125 109.042 57.3447L113 11.5913H46.5258C45.9323 20.6615 44.5552 40.9739 43.7952 49.6621Z",
  fill: "#DCDCDC"
}), React.createElement("ellipse", {
  cx: 70.3575,
  cy: 29.4784,
  rx: 3.0333,
  ry: 3.04969,
  fill: "#ADADAD"
}), React.createElement("ellipse", {
  cx: 86.2208,
  cy: 29.4784,
  rx: 3.0333,
  ry: 3.04969,
  fill: "#ADADAD"
}), React.createElement("path", {
  d: "M68.3057 45.5406C71.6134 41.2929 80.1448 35.3459 87.8088 45.5406",
  stroke: "#ADADAD",
  strokeWidth: 2
}));

var SvgNodata = function SvgNodata(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 140,
    height: 77,
    viewBox: "0 0 140 77",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNodata, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nodata.37db8906.svg";
export { ForwardRef as ReactComponent };